import React from 'react';
import { fmtRupees } from '../../utils/payoutFormat';

// Three all-time totals (sum of the per-healer summary). They do not follow the list filters.
const PayoutSummaryStrip = ({ totals, unavailable, isMobile }) => {
  const cards = [
    { label: 'On hold',      data: totals.onHold, color: '#92400e' },
    { label: 'Ready to pay', data: totals.ready,  color: '#065f46' },
    { label: 'Paid',         data: totals.paid,   color: '#1e40af' },
  ];
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 12 }}>
        {cards.map(function(c) {
          return (
            <div key={c.label} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>{c.label}</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: c.color }}>
                {unavailable ? '—' : fmtRupees(c.data.amount)}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                {unavailable ? 'Totals unavailable' : c.data.count + (c.data.count === 1 ? ' session' : ' sessions')}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>
        Totals cover all time and do not change with the filters below. Cancelled lines are not counted.
      </div>
    </div>
  );
};

export default PayoutSummaryStrip;
